export default __webpack_public_path__ + "static/media/la_jolla_cove.d5034799.png";